<template>
    <label class="weeduc-lang-switcher" :class="{ 'weeduc-lang-switcher--compact': compact }">
        <span v-if="!compact" class="weeduc-lang-switcher__label">{{ $t('common.language') }}</span>
        <select
            class="weeduc-lang-switcher__select"
            :value="currentLocale"
            :aria-label="$t('common.language')"
            @change="onChange"
        >
            <option
                v-for="option in options"
                :key="option.value"
                :value="option.value"
            >
                {{ compact ? option.short : option.label }}
            </option>
        </select>
    </label>
</template>

<script>
import { setAppLocale } from '@/i18n';

export default {
    name: 'LanguageSwitcher',
    props: {
        compact: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        currentLocale() {
            const loc = this.$i18n.locale;
            return loc && typeof loc === 'object' && 'value' in loc ? loc.value : loc;
        },
        options() {
            return [
                { value: 'pt', short: 'PT', label: this.$t('common.portuguese') },
                { value: 'en', short: 'EN', label: this.$t('common.english') },
                { value: 'es', short: 'ES', label: this.$t('common.spanish') },
            ];
        },
    },
    methods: {
        onChange(event) {
            setAppLocale(event.target.value);
        },
    },
};
</script>

<style scoped>
.weeduc-lang-switcher {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin: 0;
}

.weeduc-lang-switcher__label {
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    color: inherit;
    opacity: 0.8;
    white-space: nowrap;
}

.weeduc-lang-switcher__select {
    appearance: none;
    border: 1px solid currentColor;
    border-radius: 8px;
    background: transparent;
    color: inherit;
    font-size: 0.8rem;
    font-weight: 600;
    padding: 4px 28px 4px 10px;
    min-height: 32px;
    cursor: pointer;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='currentColor' d='M1.4.6 6 5.2 10.6.6 12 2 6 8 0 2z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 8px center;
    background-size: 10px;
}

.weeduc-lang-switcher--light .weeduc-lang-switcher__select {
    border-color: rgba(31, 30, 97, 0.25);
    color: #1f1e61;
}

.weeduc-lang-switcher--on-dark .weeduc-lang-switcher__label,
.weeduc-lang-switcher--on-dark .weeduc-lang-switcher__select {
    color: #fff;
}

.weeduc-lang-switcher--on-dark .weeduc-lang-switcher__select {
    border-color: rgba(255, 255, 255, 0.35);
}
</style>
